// import { AdminLayout } from "#layouts";
// import React from "react";
// import { useSelector } from "react-redux";
// const GrowerDetail = () => {
//   const growerDetail = useSelector((state) => state?.grower?.growerDetails);
//   return (
//     <AdminLayout>
//       <section className="main-section spacer">
//         <div className="container">
//           <div class="detail_wrapper_card">
//             <div class="row gy-3 gx-4 gx-xxl-5">
//               <div class="col-md-6 col-lg-4">
//                 <div class="common-statistics">
//                   <div class="common-info-detail">
//                     <h2 class="h4">Grower ID</h2>
//                     <p class="mb-0">{growerDetail?._id}</p>
//                   </div>
//                   <div class="common-info-detail">
//                     <h2 class="h4">Phone Number</h2>
//                     <p className="mb-0">
//                       {growerDetail?.countryCode && growerDetail?.phoneNumber
//                         ? `+ ${growerDetail.countryCode} ${growerDetail.phoneNumber}`
//                         : "NA"}
//                     </p>
//                   </div>
//                 </div>
//               </div>
//               <div class="col-md-6 col-lg-4">
//                 <div class="common-statistics">
//                   <div class="common-info-detail">
//                     <h2 class="h4">Grower</h2>
//                     <p class="mb-0">{`${growerDetail?.firstName} ${growerDetail?.lastName}`}</p>
//                   </div>
//                   <div class="common-info-detail">
//                     <h2 class="h4">Location</h2>
//                     <p class="mb-0">{growerDetail?.location}</p>
//                   </div>
//                 </div>
//               </div>
//               <div class="col-md-6 col-lg-4">
//                 <div class="common-statistics">
//                   <div class="common-info-detail">
//                     <h2 class="h4">Email Address</h2>
//                     <p class="mb-0"> {growerDetail?.email || "NA"}</p>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>
//     </AdminLayout>
//   );
// };

// export default GrowerDetail;

/* eslint-disable react-hooks/exhaustive-deps */
import { GrowerDetailCard, TabToggle } from "#components";
import globalConfig from "#constants/globalConfig.js";
import { AdminLayout } from "#layouts";
import { useEffect, useState } from "react";

import CropPlanManagement from "../cropPlanManagement";
import { useSelector, useDispatch } from "react-redux";
import { setActiveTab } from "../../redux/feature/scoutingActiveTabSlice";
import ScoutingManagement from "../scoutManagement";

const GrowerDetail = () => {
  const GrowerId = JSON.parse(
    localStorage.getItem(globalConfig.ADMIN_GROWER_ID)
  );
  const [searchScouting, setSearchScouting] = useState("");
  const [searchCropPlan, setSearchCropPlan] = useState("");
  const [tempSearch, setTempSearch] = useState("");

  const activeTab = useSelector((state) => state.scoutingActiveTab.activeTab);
  const dispatch = useDispatch();

  // Handle tab change
  const handleTabClick = (tabName) => {
    dispatch(setActiveTab(tabName));
  };

  // Determines which component to render based on activeTab
  const returnActiveTabComponent = () => {
    console.log(activeTab, "activeTab");

    if (activeTab === "Scouting") {
      return (
        <ScoutingManagement
          GrowerId={GrowerId}
          searchInputScouting={tempSearch}
        />
      );
    } else if (activeTab === "Crop Plans") {
      return (
        <div className="tab-pane fade show active">
          <CropPlanManagement searchInputCropPlanList={tempSearch} />
        </div>
      );
    }
    return null;
  };

  // Handle input change
  const handleInputChange = (e) => {
    setTempSearch(e.target.value);
  };

  // Trigger search only on Enter key press
  // const handleKeyDown = (e) => {
  //   if (e.key === "Enter") {
  //   if (activeTab === "Scouting") {
  //     setSearchScouting(tempSearch);
  //   } else {
  //     setSearchCropPlan(tempSearch);
  //   }
  //   }
  // };

  useEffect(() => {
    if (tempSearch === "") {
      if (activeTab === "Scouting") {
        setSearchScouting(tempSearch);
      } else {
        setSearchCropPlan(tempSearch);
      }
    }
  }, [tempSearch]);
  useEffect(() => {
    setTempSearch(""); // Reset tempSearch when activeTab changes
    setSearchScouting("");
    setSearchCropPlan("");
  }, [activeTab]);

  return (
    <AdminLayout>
      <section className="main-section spacer">
        <div className="container">
          <GrowerDetailCard GrowerId={GrowerId} />
          <div className="row mt-4">
            <div className="col-xl-12">
              <div className="flex-between">
                <TabToggle
                  data={["Scouting", "Crop Plans"]}
                  activeTab={activeTab}
                  handleTabClick={handleTabClick}
                />
                {/* <div className="form-block p-relative">
                  <input
                    type="text"
                    className="form-control"
                    id="search"
                    placeholder="Search"
                    value={tempSearch}
                    onChange={handleInputChange}
                    // onKeyDown={handleKeyDown} // Ensures search happens only on Enter
                  />
                  <span className="search-icon" />
                </div> */}
              </div>
              <div className="tab-content pt-4">
                {returnActiveTabComponent()}
              </div>
            </div>
          </div>
        </div>
      </section>
    </AdminLayout>
  );
};

export default GrowerDetail;
